import { MenuItem } from './MenuItem'
import { MenuInnerWithSub } from './MenuInnerWithSub'
import { MegaMenu } from './MegaMenu'
import { createContext, useContext, useState } from 'react'
import { v4 as uuidv4 } from 'uuid';




function normalizePath() {

  const nav = localStorage.getItem('navigation') as string;
  if (nav && nav !== 'undefined') {
    const menuItems = JSON.parse(nav);
    return menuItems.map((item: any) => (
      { ...item, path: item.path && !(/^\//.test(item.path)) ? `/${item.path}` : item.path }
    ))
  }
}


const Menu = ({ menuItems }: any) => {

  return (
    
    menuItems.map((item: any) => {
      return (
        item.items.length > 0 ?
          (<MenuInnerWithSub
            key={item.id}
            title={item.text}
            to={item.path}
            //icon={item.icon}
            hasArrow={item.parentId}
            menuPlacement={item.parentId ? 'right-start':'bottom-start'}
            menuTrigger={`{default:'click', lg: 'hover'}`}
          >
            {Menu({ menuItems: item.items })}
          </MenuInnerWithSub>) : item.name !== 'SupplierHome' && item.name !== 'RetailerHome' && item.name !== 'AdminHome'?
          (
            <MenuItem key={item.id} to={item.path} title={item.text} hasBullet={item.parentId} />
          ):(<div key={item.id}></div>)
      )
    })
  );
};

const MegaMenu2 = ({ menuItems }: any) => {
  const uniqueKey = uuidv4();
  return (
    <div key={uniqueKey} className='row' data-kt-menu-dismiss='true'>
      {menuItems.map((item: any) => {
        return (
          item.items.length > 0 ?
            ( <div key={item.id} className='col-lg-4 border-left-lg-1'><MenuInnerWithSub
              key={item.id}
              title={item.text}
              to={item.path}
              icon={item.icon}
              hasArrow={true}
              menuPlacement='bottom-start'
              menuTrigger={`{default:'click', lg: 'hover'}`}
            >
              {Menu({ menuItems: item.items })}
            </MenuInnerWithSub></div>) :
            (
              <div key={item.id} className='col-lg-4 border-left-lg-1'><MenuItem key={item.id} to={item.path} icon={item.icon} title={item.text} hasBullet={item.parentId} /></div>
            )

        )
      })}
    </div>

  );
};





const MenuInner = () => {
  const allMenuItems = normalizePath();
  return (
    <>
      <Menu menuItems={allMenuItems} />
      {/* <MenuInnerWithSub
        isMega={true}
        title='Menu'
        to='/mega-menu'
        menuPlacement='bottom-start'
        menuTrigger={`{default:'click', lg: 'hover'}`}
      >
        <MegaMenu2 menuItems={allMenuItems} />
      </MenuInnerWithSub> */}
    </>

  );

}

export { MenuInner }
